'use client';

import { AxiosError } from 'axios';

import { apiClient } from '@/slw/shared/global/client';
import { UploadedFile } from '@/slw/shared/types/file.type';

import { ListingPayload, UserPackage, ZipCodeResult } from './listing.type';

const API_BASE = '/listing';

export async function createListing(data: ListingPayload) {
  return await apiClient().post<ListingPayload>(`${API_BASE}/save-draft`, data);
}

export async function getListing(url: string) {
  return await apiClient().get<ListingPayload>(`${API_BASE}/find`, {
    params: { url },
  });
}

export async function updateListing(data: Partial<ListingPayload>) {
  return await apiClient().post<ListingPayload>(`${API_BASE}/update`, data);
}

export async function publishListing(data: Partial<ListingPayload>) {
  return await apiClient().post<ListingPayload>(`${API_BASE}/publish`, data);
}

export async function uploadImage(file: File) {
  const formData = new FormData();

  formData.append('file', file);

  return await apiClient().download<UploadedFile>(`${API_BASE}/upload-image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export async function deleteImage(url: string) {
  return await apiClient().delete(`${API_BASE}/delete-image`, {
    params: { url },
  });
}

export async function fetchDropdownData(type: string) {
  return await apiClient().get(`${API_BASE}/dropdown`, {
    params: { type },
  });
}

export async function checkVin(vin: string) {
  const res = await apiClient().get<boolean>('/listing/check-vin', {
    params: { vin },
    errorHandling: 'throwOnly',
  });

  return res;
}

export async function checkZipCode(countryCode: string, zipCode: string) {
  try {
    const res = await apiClient().get<ZipCodeResult>('/listing/check-zip-code', {
      params: { countryCode, zipCode },
      errorHandling: 'throwOnly',
    });

    return res;
  } catch (error) {

    if (error instanceof AxiosError) {
      return { 
        success: false, 
        data: null, 
        message: error.response?.data?.message || error.message || 'Validation failed' 
      };
    }

    return { success: false, data: null, message: (error as Error).message || 'Validation error' };
  }
}

export async function getUserPackages() {
  const res = await apiClient().get<UserPackage[]>('/listing/user-package');

  return res.data;
}
